"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var useRenderProp_1 = require("./useRenderProp");

var useAdopt = function useAdopt(map) {
  var keys = Object.keys(map);
  var fragments = [];
  var result = {};
  keys.sort();

  for (var _i = 0; _i < keys.length; _i++) {
    var key = keys[_i];

    var _useRenderProp_1$defa = useRenderProp_1.default(map[key]),
        _useRenderProp_1$defa2 = _slicedToArray(_useRenderProp_1$defa, 2),
        fragment = _useRenderProp_1$defa2[0],
        value = _useRenderProp_1$defa2[1];

    fragments.push(React.cloneElement(fragment, {
      key: key
    }));
    result[key] = value;
  }

  return [React.createElement.apply(React, [React.Fragment, null].concat(fragments)), result];
};

exports.default = useAdopt;